/**
 * ChartHead — back-arrow + title + birth meta line.
 * Verbatim port of mobile.html `.chart-head`.
 */
import { useRouter } from "@tanstack/react-router";
import type { ReactElement } from "react";

export interface ChartHeadProps {
  readonly title: string;
  readonly meta: string;
}

export function ChartHead({ title, meta }: ChartHeadProps): ReactElement {
  const router = useRouter();
  return (
    <div className="chart-head">
      <button
        type="button"
        className="chart-back"
        aria-label="Назад"
        onClick={() => router.history.back()}
      >
        ‹
      </button>
      <div className="chart-headtext">
        <div className="chart-title">{title}</div>
        <div className="chart-meta">{meta}</div>
      </div>
    </div>
  );
}
